import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://www.baiyunvideo.com${item.href}` : undefined,
    })),
  };

  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1.5">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
          )}
          {item.href ? (
            <Link
              to={item.href}
              className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}